import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pricingOrderAmount',
})
export class PricingOrderAmountPipe implements PipeTransform {
  transform(amounts :any, property :string) :number[] {
    return amounts.sort(
      (a :any, b :any) => Number(b[property]) - Number(a[property]),
    );
  }
}
